import * as React from "react";
import ReactDOM from "react-dom";
import { reaction } from "mobx";
import PropTypes from "prop-types";
import FetchStore from "../../stores/FetchStore";
import "./style.css";

const statusRoot = document.getElementById("status-root");

class ProgressBar extends React.Component {
  static propTypes = {
    children: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.el = document.createElement("div");
  }

  componentDidMount() {
    statusRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    statusRoot.removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.el);
  }
}

class ParentProgressBar extends React.Component {
  _isMounted = false;

  static propTypes = {
    classes: PropTypes.object
  };

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  constructor(props) {
    super(props);
    this.state = {
      _cancel: null,
      _gauge: 0,
      _buffer: 0,
      _show: false
    };

    this._start = this.start.bind(this);
    this._stop = this.stop.bind(this);
    this._onListener = this.onListener.bind(this);

    reaction(() => FetchStore.fetching, this._onListener);
  }

  onListener() {
    if (FetchStore.fetching && !this.state._cancel) {
      this.start();
    }

    if (!FetchStore.fetching && this.state._cancel) {
      this.stop();
    }
  }

  stop = () => {
    if (this._isMounted) {
      this.setState(prevState => {
        window.cancelAnimationFrame(prevState._cancel);
        return {
          _cancel: 0,
          _gauge: 0,
          _buffer: 10,
          _show: false
        };
      });
    }
  };

  start = () => {
    const start = new Date();
    const aThis = this;

    function step() {
      const elapsedTime = new Date() - start;
      const progress = (Math.atan(elapsedTime / 3e3) / (Math.PI / 2)) * 100;
      if (aThis._isMounted) {
        if (progress < 95) {
          aThis.setState({
            _show: true,
            _cancel: window.requestAnimationFrame(step),
            _gauge: Math.min(progress, 100),
            _buffer: Math.min(progress, 100) + Math.random() * 10 + Math.random() * 10
          });
        }
      }
    }

    if (aThis._isMounted) {
      this.setState({ _cancel: window.requestAnimationFrame(step), _gauge: 0 });
    }
  };

  render() {
    const { _gauge } = this.state;
    return (
      <ProgressBar>
        <div id="loaderbar" className="loaderbar">
          <div id="progressbar" className="progress" style={{ width: `${_gauge}%` }} />
        </div>
      </ProgressBar>
    );
  }
}

export default ParentProgressBar;



// WEBPACK FOOTER //
// ./src/components/ProgressBar/index.js